





































































import { Component, Watch } from 'vue-property-decorator';
import MixinDialog from '@/plugins/podolib/services/helper/mixins/dialog';
import { TForm } from '@/plugins/podolib/lib/types';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TStation } from '@/plugins/podolib/services/entities/EntityStations';
import { Severity } from '@sentry/types';

type TFields = {
  name: {
    value: string;
  };
};

interface IEquipmentsStationEditDialog extends MixinDialog {
  _open(station: TEntity<TStation>): void;
}

@Component<IEquipmentsStationEditDialog>({
  mounted() {
    this.$pdc.bus!.on('station:edit', this._open);
  },
  beforeDestroy() {
    this.$pdc.bus!.off('station:edit', this._open);
  },
})
export default class EquipmentsStationEditDialog extends MixinDialog {
  station: TEntity<TStation> = null!;

  form: TForm<TFields> = {
    fields: {
      name: {
        value: '',
      },
    },
    pending: false,
    error: null,
    success: false,
  };

  @Watch('dialog')
  onDialogChanged(state: boolean) {
    if (state) {
      // Populate form
      this.form.fields.name.value = this.station.name;
      // Reset flags
      this.form.success = false;
      this.form.error = null;
    }
  }

  @Watch('form.fields', { deep: true })
  onFormFieldsDeeplyChanged(newFormFields: TFields) {
    // To avoid flash css switch
    if (!this.dialog) return;
    if (this.form.success) return;
    // Reset flags
    this.form.success = false;
    this.form.error = null;
  }

  _open(station: TEntity<TStation>) {
    this.station = station;

    this.open();
  }

  async save() {
    try {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      // Reset flags
      this.form.success = false;
      this.form.error = null;
      // Set 'pending' flag
      this.form.pending = true;
      // Try to patch the station ...
      await this.$pdc.repository!.patchRessource({
        ressource: 'stations',
        params: {
          _id: this.station._id,
        },
        data: {
          name: this.form.fields.name.value,
        },
      });
      // Set 'success' flag
      this.form.success = true;
    } catch (e) {
      // Set 'error' flag
      this.form.error = e;
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Error);
    } finally {
      // Reset 'pending' flag
      this.form.pending = false;
    }
  }

  reset() {
    this.form.fields.name.value = this.station.name;
  }
}
